import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const LocalizationRoute = lazyWithRetries(() => import('.'))
const TranslationsRoute = lazyWithRetries(() => import('./translations'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.localization(),
    element: (
      <StandardPageLayout
        elementId="localizationRoute"
        maxWidth={900}
        title={<T _str="Language & time" />}>
        <Suspense fallback={<RouteLoading />}>
          <LocalizationRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.translations(':languageId?', ':tab?'),
    element: (
      <StandardPageLayout maxWidth={900} elementId="translationsRoute">
        <Suspense fallback={<RouteLoading />}>
          <TranslationsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
